import angular from 'angular';

import LogoComponent from './logo.cmpt';

export default angular.module('common.logo', [])
    .component(LogoComponent.selector, LogoComponent);



// WEBPACK FOOTER //
// ./src/common/component/logo/index.js